// Home.js
import React from "react";
import "./Home.css";
import SEO from "../Components/SEO";
import { PRODUCT_IMAGES } from "../Components/ProductImages";

function Home() {
  return (
    <>
      {" "}
      <SEO
        title="Topical Luteolin Serum"
        description="High-purity topical luteolin serum designed to support hair vitality and skin antioxidant protection."
      />
      <main className="home-page" role="main" aria-label="Lutology Homepage">
        <section className="hero-section">
          <h1>Lutology – Topical Luteolin Serum</h1>

          {/* Trust line: concise, legal-safe descriptor */}
          <p className="trust-line">
            A science-driven topical serum designed for antioxidant scalp
            support.
          </p>

          <p>
            Lutology is a <strong>topical Luteolin serum</strong> designed to
            support the scalp’s antioxidant balance, something that is
            increasingly highlighted in research exploring the way hair looks as
            it ages. Its simple and focused formula helps maintain a healthy
            scalp environment and the natural appearance of hair over time.
          </p>

          <img
            src={PRODUCT_IMAGES["topical-luteolin-serum"].heroImage}
            alt="Lutology Topical Luteolin Serum – Product Image"
            className="hero-image"
          />
        </section>

        <section className="highlights">
          <h2>Discover the Power of Topical Luteolin for Hair</h2>
          <p>
            Backed by emerging studies, <strong>topical Luteolin</strong> offers
            antioxidant and protective effects. Ideal for those who prefer
            science-inspired haircare.
          </p>

          <ul>
            <li>Formulated with high-purity Luteolin</li>
            <li>Supports scalp comfort & calmness</li>
            <li>No Synthetic Fragrance</li>
            <li>Minimalist formula</li>
            <li>Vegan</li>
          </ul>
        </section>

        <section className="quote-section">
          <blockquote>
            “We’re not trying to be everything. We’re trying to be the one thing
            that works.”
          </blockquote>
        </section>

        <section className="cta-bottom">
          <p>
            Start your hair journey with Lutology's{" "}
            <strong>Topical Luteolin Serum</strong> today.
          </p>
        </section>

        <section className="seo-footer">
          <p>
            Lutology is one of the only dedicated Unlike generic haircare, our
            serum focuses on delivering high-purity Luteolin for effective scalp
            application and antioxidant support.
          </p>
          <p>
            Developed by a bio-startup and crafted in Tel Aviv, Lutology offers
            a pure, science-inspired formula.
          </p>
        </section>
      </main>
    </>
  );
}

export default Home;